const customer = {
    name: 'Kinder Morgan',

    emails: {
        pods: 'PODSILI@kindermorgan.com',
        corrosion: 'corrosion@kindermorgan.com'
    }
}

export default customer;